import Vue from 'vue'

/**
 * 注销账户
 * @param {*} params
 */
export const accountCancellation = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/accountCancellation', params)
}

/**
 * 检查登录手机
 * @param {*} params
 */
export const checkPhoneBind = params => {
  return Vue.fetch.post('/apiv1/account/checkBindWhere', params)
}

/**
 * 解除微信绑定
 * @param {*} params
 */
export const unboundWeChat = params => {
  return Vue.fetch.post('/apiv1/account/unboundWeChat', params)
}

/**
 * 微信扫码回调处理结果检测
 * @param {*} params
 */
export const checkScan = params => {
  return Vue.fetch.post('/apiv1/wx/checkScan', params)
}

/**
 * 获取微信二维码
 * @param {*} params
 */
export const getWeChatCode = params => {
  return Vue.fetch.post('/apiv1/wx/getWeChatCode', params)
}

/**
 * 通用校验验证码
 * @param {*} params
 */
export const comCheckCode = params => {
  return Vue.fetch.post('/apiv1/account/checkVerifyCode', params)
}

/**
 * 修改邮箱and手机
 */
export const updateEmailAndPhone = params => {
  return Vue.fetch.post('/apiv1/account/updateUserBingEmailAndPhone', params)
}

/**
 * 修改手机
 * @param {*} params
 */
export const rebindPhone = params => {
  return Vue.fetch.post('/apiv1/account/rebindPhone', params)
}

/**
 * 发送手机验证码
 * @param {*} params
 */
export const sendPhoneCode = params => {
  return Vue.fetch.post('/apiv1/account/sendPhoneCode', params)
}

/**
 * 绑定手机
 * @param {*} params
 */
export const bindPhone = params => {
  return Vue.fetch.post('/apiv1/account/bindPhone', params)
}

/**
 * 绑定邮箱
 */
export const bindEmail = params => {
  return Vue.fetch.post('/apiv1/account/bindEmail', params)
}

/**
 * 获取验证码
 */
export const getEmailCode = params => {
  return Vue.fetch.post('/apiv1/account/sendEmailCode', params)
}

/**
 * 修改昵称
 */
export const updateNickName = params => {
  return Vue.fetch.post('/apiv1/account/updateUserNickName', params)
}

/**
 * 上传头像
 */
export const uploadAvatar = params => {
  return Vue.fetch.post('/apiv1/account/updateUserNickName', params)
}

/**
 * 用户中心详情
 */
export const getPersonCenterDetail = params => {
  return Vue.fetch.post('/apiv1/account/queryPersonalCenterByLoginName', params)
}

/**
 * 校验验证码（通过后不删除）
 */
export const verifyCode = params => {
  return Vue.fetch.post('/apiv1/account/verifyCode', params)
}



// WEBPACK FOOTER //
// ./src/services/userCenter.js